import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import './Paginacion.css';

/**
 * Componente reutilizable de paginación para FactuBox
 * @param {Number} paginaActual - Página actual (1-indexed)
 * @param {Number} totalPaginas - Total de páginas
 * @param {Number} totalRegistros - Total de registros
 * @param {Number} registrosPorPagina - Registros por página
 * @param {Function} onCambioPagina - Callback cuando cambia la página
 */
function Paginacion({ paginaActual, totalPaginas, totalRegistros, registrosPorPagina, onCambioPagina }) {
  // Calcular rango de registros mostrados
  const inicio = totalRegistros === 0 ? 0 : (paginaActual - 1) * registrosPorPagina + 1;
  const fin = Math.min(paginaActual * registrosPorPagina, totalRegistros);

  // No mostrar paginación si no hay registros o solo hay una página
  if (totalRegistros === 0 || totalPaginas <= 1) {
    return null;
  }

  return (
    <div className="paginacion">
      <div className="paginacion-info">
        Mostrando {inicio} - {fin} de {totalRegistros} {totalRegistros === 1 ? 'registro' : 'registros'}
      </div>
      <div className="paginacion-controles">
        <button
          onClick={() => onCambioPagina(1)}
          disabled={paginaActual === 1}
          title="Primera página"
          className="btn-paginacion"
        >
          <ChevronsLeft size={18} />
        </button>
        <button
          onClick={() => onCambioPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
          title="Página anterior"
          className="btn-paginacion"
        >
          <ChevronLeft size={18} />
        </button>
        <span className="pagina-actual">
          Página {paginaActual} de {totalPaginas}
        </span>
        <button
          onClick={() => onCambioPagina(paginaActual + 1)}
          disabled={paginaActual === totalPaginas}
          title="Página siguiente"
          className="btn-paginacion"
        >
          <ChevronRight size={18} />
        </button>
        <button
          onClick={() => onCambioPagina(totalPaginas)}
          disabled={paginaActual === totalPaginas}
          title="Última página"
          className="btn-paginacion"
        >
          <ChevronsRight size={18} />
        </button>
      </div>
    </div>
  );
}

export default Paginacion;
